import dayjs from 'dayjs';
import LOCALIZED_FORMAT_PLUGIN from 'dayjs/plugin/localizedFormat';
import RelativeTimePlugin from 'dayjs/plugin/relativeTime';

dayjs.extend(LOCALIZED_FORMAT_PLUGIN);
dayjs.extend(RelativeTimePlugin);
export const getFormattedDate = (value, format) => {
  if (value) {
    return dayjs(value).format(format || 'L');
  }
  return null;
};

export const renderRelativeDate = (text, format = 'y') => {
  if (text) {
    return dayjs().diff(text, format);
  }
  return text;
};

export const IsTeenager = value => {
  let yearDifference;
  if (value) {
    yearDifference = dayjs().diff(value, 'year');
  }
  if (yearDifference !== undefined) {
    return yearDifference < 18;
  }
  return false;
};

export function getRelativeDateFromNow(value) {
  if (value) {
    const date = dayjs(value);
    return date.fromNow();
  }
  return null;
}

export function calculateAge(birthdate) {
  // Current date
  const now = dayjs();

  // Birth date
  const birth = dayjs(birthdate);

  // Calculate difference in years
  const years = now.diff(birth, 'year');

  // Calculate remaining days by adding the years back to the birth date
  // and getting the difference from now
  const adjustedBirthDateThisYear = birth.add(years, 'year');
  const days = now.diff(adjustedBirthDateThisYear, 'day');

  return {
    years,
    days,
  };
}
